import { render } from "./FinishAssignPosition.vue?vue&type=template&id=7e60bf8c"
import script from "./FinishAssignPosition.vue?vue&type=script&lang=js"
export * from "./FinishAssignPosition.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__